import React from "react";

import { NotImplementedField } from "../../formComponents/NotImplementedField";
import type { FormFieldFactoryProps } from "../../types/types";
import { VerticalFormFieldsMap } from "../Vertical/VerticalFormFieldsMap";
import { VerticalFormFieldWrapper } from "../Vertical/VerticalFormFieldWrapper";
import { HorizontalFormFieldsMap } from "./HorizontalFormFieldsMap";
import { HorizontalFormFieldWrapper } from "./HorizontalFormFieldWrapper";

export const createHorizontalFormField = (props: FormFieldFactoryProps) => {
    // if there is a field in HorizontalMap, use that, if not, check verticalMap, if not, use notImplementedField. For use with full-width tables in forms
    const field = HorizontalFormFieldsMap[props.field.component] ? (
        <HorizontalFormFieldWrapper
            field={props}
            formComponent={React.createElement(HorizontalFormFieldsMap[props.field.component] || NotImplementedField, {
                ...props,
                className: "aevi-form-field-horizontal",
            })}
        />
    ) : (
        <VerticalFormFieldWrapper
            field={props}
            formComponent={React.createElement(VerticalFormFieldsMap[props.field.component] || NotImplementedField, {
                ...props,
                className: "aevi-form-field-vertical",
            })}
        />
    );
    return React.cloneElement(field, { ...props });
};
